import { ReleasePage, ReleasePageData } from '../types/ReleaseContentType';
import { getReleasePageData } from '../utils/releases';

export const useReleasePageData = (props: ReleasePage): ReleasePageData => {
  return getReleasePageData(props);
};
